export const imagesFormats = [
  'image/x-png',
  'image/png',
  'image/gif',
  'image/jpeg',
];
